import styled from "@emotion/styled"
import { Button } from "@blueprintjs/core"
import { FlexContainer } from "../../../../styled/flexbox.styled"
import { SCIENT_COLORS } from "../../../../styled/scientColors"

export const UploadContainer = styled(FlexContainer)({
  width: "100%",
  marginTop: "10px",
  paddingTop: "10px",
  borderTop: `1px solid ${SCIENT_COLORS.darkGray3}`,
})

export const UploadButton = styled(Button)({
  width: "100%",
})

export const UploadInfoText = styled.div({
  fontSize: "11px",
  color: SCIENT_COLORS.lightGray1,
  marginTop: "5px",
  lineHeight: "1.4",
})

